import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/modules/shared.module';
import { RouterModule } from '@angular/router';

import { AuthService } from './auth.service';

import { AuthComponent } from './auth.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotLoginComponent } from './forgot-login/forgot-login.component';
import { ImpersonateUserComponent } from './impersonate-user/impersonate-user.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CreateProfileComponent } from './create-profile/create-profile.component';
import { SignInComponent } from './sign-in/sign-in.component';

import {NgxCaptchaModule } from "ngx-captcha";
import { NgxMaskModule } from 'ngx-mask';
import { DatePipe } from '@angular/common';



@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxCaptchaModule,
    NgxMaskModule.forRoot()
  ],
  declarations: [
    AuthComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    ForgotLoginComponent,
    ImpersonateUserComponent,
    CreateAccountComponent,
    CreateProfileComponent,
    ResetPasswordComponent,
    SignInComponent
  ],
  providers: [ 
    AuthService,
    DatePipe
]
})
export class AuthModule { }
